import { useEffect, useMemo } from 'react';
import { v4 } from 'uuid';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import breadcrumbsAdd from 'src/react/components/breadcrumbs/actions/add';
import breadcrumbsRemove from 'src/react/components/breadcrumbs/actions/remove';
import breadcrumbsUpdate from 'components/breadcrumbs/actions/update';

var Breadcrumb = function Breadcrumb(_ref) {
  var title = _ref.title,
      url = _ref.url,
      _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? true : _ref$isVisible,
      add = _ref.add,
      update = _ref.update,
      remove = _ref.remove;

  if (!isVisible) {
    return null;
  }

  var id = useMemo(function () {
    return v4();
  }, []);

  var buildCrumb = function buildCrumb() {
    return {
      id: id,
      title: title,
      url: url
    };
  };

  useEffect(function () {
    add(buildCrumb());
    return function () {
      remove(id);
    };
  }, [isVisible]);
  useEffect(function () {
    update(buildCrumb());
  }, [title, url]);
  return null;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    add: breadcrumbsAdd,
    update: breadcrumbsUpdate,
    remove: breadcrumbsRemove
  }, dispatch);
};

export default connect(undefined, mapDispatchToProps)(Breadcrumb);